export const FETCH_PRECEDENTS = '@precedent/FETCH_PRECEDENTS'
export const FETCH_PRECEDENTS_SUCCESS = '@precedent/FETCH_PRECEDENTS_SUCCESS'
export const FETCH_PRECEDENTS_FAILURE = '@precedent/FETCH_PRECEDENTS_FAILURE'

export const CREATE_PRECEDENT = '@precedent/CREATE_PRECEDENT'
export const CREATE_PRECEDENT_SUCCESS = '@precedent/CREATE_PRECEDENT_SUCCESS'
export const CREATE_PRECEDENT_FAILURE = '@precedent/CREATE_PRECEDENT_FAILURE'
